import * as React from 'react';

import Stack , { StackProps } from '@mui/material/Stack';
import { BoxProps } from '@mui/material/Box';
import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';

export interface IEntireFormProps extends BoxProps, StackProps {
    disabled?: boolean,
    children?: React.ReactElement | React.ReactNode
}

export const getEntireFormStyle = (disabled:boolean,readOnly?:boolean):SxProps<Theme> => {
    if (disabled) {
        return {
            '& .MuiCheckbox-root':{ opacity:0.8 },
            '& .MuiFormControl-root': { pointerEvents: 'none' },
            '& input, & .MuiSelect-select,& label, & textarea, & .label': { color:'text.disabled' },
        }
    }
    return {}
}

export default function EntireForm({ disabled = false, sx, children, ...other }: IEntireFormProps) {

    let compoundStyle = {
        ...getEntireFormStyle(disabled),
        ...sx
    } as SxProps<Theme>

    return (
        <Stack component="form" sx={compoundStyle} {...other}>
            {children}
        </Stack>
    );
}
